module.exports = __webpack_public_path__ + "img/ElectricCarOutlined.3d210787.svg";